<div class="password-requirements-container" role="alert" aria-live="polite">
    <div class="strength-meter-container">
       <div class="strength-meter-background"
           [ngClass]="getBackgroundClasses()">
          <div
             class="strength-meter-progress"
             [ngClass]="getStrengthBarClasses()"
             [style.width.%]="strengthPercentage"
             [attr.aria-label]="'password-requirements_strength-meter-aria' | translate">
          </div>
       </div>
    </div>

    <div class="length-requirement">
      <span
         class="requirement-icon"
         [ngClass]="{'fulfilled': lengthRequirement.fulfilled, 'unfulfilled': !lengthRequirement.fulfilled}"
         aria-hidden="true">
        <i class="icon-color-override" [ngClass]="lengthRequirement.fulfilled ? 'ficon-app-checkmark' : 'ficon-app-warning-circle-outline'"></i>
      </span>
      <span class="requirement-text">
        {{ lengthRequirement.text | translate }}
        <span class="sr-only">{{ (lengthRequirement.fulfilled ? 'password-requirements_completed' : 'password-requirements_not-completed') | translate }}</span>
      </span>
    </div>

    <div class="requirements-container">
       <p class="requirements-description">
          <strong>{{ 'password-requirements_contains-three' | translate }}</strong>
       </p>

       <ul class="requirements-list">
          <li *ngFor="let requirement of requirements" class="requirement-item">
             <span
                *ngIf="requirement.fulfilled"
                class="requirement-icon fulfilled"
                aria-hidden="true">
                <i class="icon-color-override ficon-app-checkmark"></i>
             </span>

             <span
                *ngIf="!requirement.fulfilled && !enoughOptionalRequirementsMet()"
                class="requirement-icon unfulfilled"
                aria-hidden="true">
                <i class="icon-color-override ficon-app-warning-circle-outline"></i>
             </span>

             <span
                *ngIf="!requirement.fulfilled && enoughOptionalRequirementsMet()"
                class="requirement-icon"
                aria-hidden="true">
                <!-- Empty space with same width -->
                <i class="icon-placeholder"></i>
             </span>

             <span class="requirement-text">
                {{ requirement.text | translate }}
                <span class="sr-only">{{ (requirement.fulfilled ? 'password-requirements_completed' : 'password-requirements_not-completed') | translate }}</span>
             </span>
          </li>
       </ul>
    </div>
</div>
